module.exports = __webpack_public_path__ + "static/media/ayandeh.e79f967a.svg";